const SearchActionTypes = {
    GET_RESULTS: 'GET_RESULTS'
};

export default SearchActionTypes;
